export const CombosMAEnum = {
  flex: 1,
};
